import request from '@/utils/request.js'

export function getAgentAccount(data){
    return request({
        url: 'agent/account/list',
        method: 'post',
        data
    })
}

export function getAccountData(data){
    return request({
        url: 'agent/account/flow/list',
        method: 'post',
        data
    })
}
export function getDataStatistics(data){
    return request({
        url: 'ctcc/pool/info',
        method: 'get',
        params: data
    })
}
export function getSupplierFlux(data){
    return request({
        url: 'ctcc/pool/list',
        method: 'get',
        params: data
    })
}

export function getOrderTop5(){
    return request({
        url: 'agent/order/top5',
        method: 'get'
    })
}

export function dataStatistics(){
    return request({
        url: 'agent/order/dataStatistics',
        method: 'get'
    })
}

//数据汇总
export function agentDataStatistics(){
    return request({
        url: 'agent/order/agentDataStatistics',
        method: 'get'
    })
}
//数据汇总
export function agentDataStatistics1(){
    return request({
        url: 'agent/order/agentDataStatistics/yewu',
        method: 'get'
    })
}
export function getAgentCount(){
    return request({
        url: 'agentCount/sys/infos',
        method: 'post'
    })
}

export function selectAllData(){
    return request({
        url: 'lunxun/selectAllData',
        method: 'get'
    })
}
export function selectCitys(data){
    return request({
        url: 'lunxun/selectCitys',
        method: 'get',
        params:data
    })
}